import { DBRow, DataRecord } from '@cloudio-saas/datasource-types';
import { Theme } from '@mui/material';
import { Platform } from 'componentregistry';

let counter = 0;

export function uid(name?: string) {
  return new Id(`O-${name ?? ''}-${++counter}`);
}

class Id {
  id: string;
  href: string;

  constructor(id: string) {
    this.id = id;
    // eslint-disable-next-line no-restricted-globals
    this.href = new URL(`#${id}`, location.toString()) + '';
  }

  toString = (): string => {
    return 'url(' + this.href + ')';
  };
}

export interface D3Props {
  dataset: DBRow<DataRecord>[];
  platform: Platform;
  svg: d3.Selection<SVGSVGElement, unknown, null, undefined>;
  width: number;
  height: number;
  itemId: string;
  appUid: string;
  pageId: string;
  onClickTrigger?: (
    event?: React.SyntheticEvent<HTMLOrSVGElement, Event>,
    extraProps?: Record<string, unknown>,
    itemId?: string,
  ) => Promise<boolean>;
  theme: Theme;
  rootRef: React.RefObject<HTMLDivElement>;
  tooltipRef: React.RefObject<HTMLDivElement>;
}
